import type { CadastroPromocaoFidelidadeModel } from "../models/cadastroPromocaoFidelidadeModel"

export enum CadastroPromocaoFidelidadeActionsTypes {
    CARREGAR = "CARREGAR",
    ATUALIZAR_CAMPO = "ATUALIZAR_CAMPO",
}

export type CadastroPromocaoFidelidadeActionModel =
    | {
          type: CadastroPromocaoFidelidadeActionsTypes.CARREGAR
          payload: CadastroPromocaoFidelidadeModel
      }
    | {
          type: CadastroPromocaoFidelidadeActionsTypes.ATUALIZAR_CAMPO
          payload: {
              campo: keyof CadastroPromocaoFidelidadeModel
              valor: string | boolean | number
          }
      }
